import { useMemo } from 'react'
import Skeleton from '@mui/material/Skeleton'

import { PassContext } from "/components/editor/pass-context"
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined'

import AppleFront from "/components/editor/apple/front"
import AppleLockScreen from "/components/editor/apple/lock-screen"
import AppleBack from "/components/editor/apple/back"
import GoogleFront from "/components/editor/google/front"
import GoogleListItem from "/components/editor/google/list-item"
import GoogleBack from "/components/editor/google/back"

const WizardPreview = ({ clientId, smartixPassType, applePassType, appleSubType, googlePassType, googleSubType, templateId, model, template, classData, objectData, instanceData, scannerInstanceData }) => {

  const loaded = (smartixPassType !== "none" && !!model && !!template && !!instanceData)

  const appLinkData = useMemo(() => {
    if (googlePassType === "generic") {
      if (objectData) return objectData.appLinkData
    } else {
      if (classData) return classData.appLinkData
    }
  },[googlePassType,objectData,classData])

  const appLinkLabel = useMemo(() => {
    if (appLinkData) {
      if (appLinkData.displayText) return appLinkData.displayText?.defaultValue.value
      if (appLinkData.androidAppLinkInfo) return appLinkData.androidAppLinkInfo.appTarget.packageName
      if (appLinkData.webAppLinkInfo) return appLinkData.webAppLinkInfo.appTarget.targetUri.description
    }
  },[appLinkData])

  return (
    <div style={{ width: 780 }} className='h-full overflow-y-auto overflow-x-hidden '>
      <div className='flex flex-col gap-5 preview'>
        <div className='flex flex-row gap-5'>
          <Apple title="Apple IOS Lock Screen" clientId={clientId} templateId={templateId} smartixPassType={smartixPassType} instanceData={instanceData} scannerInstanceData={scannerInstanceData} model={model} template={template} passType={applePassType} subType={appleSubType}>
            {loaded ? <AppleLockScreen /> : <Skeleton variant="rectangular" width="100%" height={200} />}
          </Apple>

          <Google title="Google Pass List Item Front" clientId={clientId} templateId={templateId} smartixPassType={smartixPassType} instanceData={instanceData} scannerInstanceData={scannerInstanceData} objectData={objectData} classData={classData} passType={googlePassType} subType={googleSubType}>
            {loaded ? <GoogleListItem /> : <Skeleton variant="rectangular" width="100%" height={200} />}
          </Google>
        </div>

        <div className='flex flex-row gap-5'>
          <Apple title={`Apple IOS Front (${applePassType})`} clientId={clientId} templateId={templateId} smartixPassType={smartixPassType} instanceData={instanceData} scannerInstanceData={scannerInstanceData} model={model} template={template} passType={applePassType} subType={appleSubType}>
            {loaded ? <AppleFront /> : <Skeleton variant="rectangular" width="100%" height={600} />}
          </Apple>

          <div>
            <Google title={`Google Android Front (${googlePassType})`} clientId={clientId} templateId={templateId} smartixPassType={smartixPassType} instanceData={instanceData} scannerInstanceData={scannerInstanceData} objectData={objectData} classData={classData} passType={googlePassType} subType={googleSubType}>
              {loaded ? <GoogleFront /> : <Skeleton variant="rectangular" width="100%" height={600} />}
            </Google>
            {appLinkLabel && <div style={{ backgroundColor: "#fff", marginTop: 20, color: "#000", padding: 10, paddingLeft: 25, borderRadius: 20 }}><OpenInNewOutlinedIcon /> {appLinkLabel}</div>}
          </div>
        </div>

        <div className='flex flex-row gap-5'>
          <Apple title="Apple IOS Back" clientId={clientId} templateId={templateId} smartixPassType={smartixPassType} instanceData={instanceData} scannerInstanceData={scannerInstanceData} model={model} template={template} passType={applePassType} subType={appleSubType}>
            {loaded ? <AppleBack /> : <Skeleton variant="rectangular" width="100%" height={600} />}
          </Apple>

          <Google title="Google Android Back" clientId={clientId} templateId={templateId} smartixPassType={smartixPassType} instanceData={instanceData} scannerInstanceData={scannerInstanceData} objectData={objectData} classData={classData} passType={googlePassType} subType={googleSubType}>
            {loaded ? <GoogleBack /> : <Skeleton variant="rectangular" width="100%" height={600} />}
          </Google>
        </div>
      </div>
    </div>
  )
}

export default WizardPreview

const Apple = ({ children, title, clientId, templateId, smartixPassType, model, template, instanceData, scannerInstanceData, passType, subType }) => (
  <div className="apple">
    <div className="wrapper"> {/* Put apple pass on a grey background with drop shadow */}
      <div className="title ml-5">{title}</div>
      <div className="pass" id="appleFront"> {/* id="appleFront" required for the image grab for the minature at the top of the back fields*/}
        <PassContext.Provider value={{ device: "apple", preview: true, clientId, templateId, smartixPassType, showEditableFields: false, model, template, instanceData, scannerInstanceData, passType, subType }}>
          {children}
        </PassContext.Provider>
      </div>
    </div>
  </div>
)


const Google = ({ children, title, clientId, templateId, smartixPassType, classData, objectData, instanceData, scannerInstanceData, passType, subType }) => (
  <div className="google">
    <div className="wrapper"> {/* Put apple pass on a grey background with drop shadow */}
      <div className="title ml-5">{title}</div>
      <div className="pass">
        <PassContext.Provider value={{ device: "google", preview: true, clientId, templateId, smartixPassType, showEditableFields: false, classData, objectData, instanceData, scannerInstanceData, passType, subType }}>
          {children}
        </PassContext.Provider>
      </div>
    </div>
  </div>
)